import React, { Component } from 'react';
import moment from 'moment-jalaali';
import styles from '../../../../Assets/Styles/Components/Book/BookTime/Calendar/calendar.module.css';

moment.loadPersian();

const DayNames = () => (
    <div className={`${styles.week} ${styles.names}`}>
        <span className={styles.dayOfWeek}> ش </span>
        <span className={styles.dayOfWeek}> ی </span>
        <span className={styles.dayOfWeek}> د </span>
        <span className={styles.dayOfWeek}> س </span>
        <span className={styles.dayOfWeek}> چ </span>
        <span className={styles.dayOfWeek}> پ </span>
        <span className={styles.dayOfWeek}> ج </span>
    </div>
);

const Week = ({ date, month, select, selected, forbiddenDays, choicedDay }) => {
    const days = [];
    let i = 0;
    while (i < 7) {
        const day = {
            name: date.format('jdd').substring(0, 1),
            number: date.jDate(),
            isCurrentMonth: date.jMonth() === month.jMonth(),
            isToday: date.isSame(new Date(), 'day'),
            isBefore: date.isBefore(new Date(), 'day'),
            date,
        };

        let className = styles.day +
            (day.isToday ? ` ${styles.today} ` : '') +
            (day.isCurrentMonth ? '' : ` ${styles.differentMonth} ${styles.deactive} `) +
            (day.date.isSame(selected) ? ` ${styles.selected} ` : '') +
            (day.isCurrentMonth && day.isBefore ? ` ${styles.deactive} ` : '  ');

        for (const j of forbiddenDays) {
            className += (i === (j - 1) ? ` ${styles.deactive} ` : '');
        }

        days.push(
            <span
                className={`${className} ${(choicedDay === day.date.format('jYYYY/jM/jD')) ? styles.selected : ''}`}
                key={`${day.date.format('jYYYY/jMM/jDD')}`}
                onClick={() => { !className.includes(`${styles.deactive}`) && select(day, i); }}
            >
                {day.number}
            </span>,
        );

        date = date.clone();
        date.add(1, 'd');
        i += 1;
    }

    return (
        <div className={styles.week} key={days[0].toString()}> {days} </div>
    );
};

const RenderWeeks = ({ month, select, selected, forbiddenDays, choicedDay }) => {
    const weeks = [];
    let done = false;
    const date = month.clone().startOf('jMonth').weekday(0);
    let monthIndex = date.jMonth();
    let count = 0;

    while (!done) {
        weeks.push(
            <Week
                key={date.toString()}
                date={date.clone()}
                month={month}
                select={select}
                selected={selected}
                forbiddenDays={forbiddenDays}
                choicedDay={choicedDay}
            />,
        );
        date.add(1, 'w');
        done = (count += 1) > 2 && monthIndex !== date.jMonth();
        monthIndex = date.jMonth();
    }
    return <div className={styles.weeksContainer}> {weeks} </div>;
};

class Calendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentMonth: moment().startOf('jMonth'),
            month: moment().startOf('jMonth'),
            selectedDay: moment().startOf('jDay'),
        };
    }

    previous = () => {
        const { month } = this.state;
        const newMonth = month.clone();
        this.setState({ month: newMonth.subtract(1, 'jM') });
    }

    next = () => {
        const { month } = this.state;
        const newMonth = month.clone();
        this.setState({ month: newMonth.add(1, 'jM') });
    }

    today = () => {
        const { onChange } = this.props;
        this.setState({
            month: moment().startOf('jMonth'),
            selectedDay: moment().startOf('jDay'),
        });
    }

    select = (day) => {
        const { onChange } = this.props;
        this.setState({ selectedDay: day.date });
        onChange && onChange(day.date.format('jYYYY/jMM/jDD'));
    }

    render() {
        const { currentMonth, month, selectedDay } = this.state;
        const { choicedDay, avilabelsDays } = this.props;
        const allweeks = [1, 2, 3, 4, 5, 6, 7];
        const forbiddenDays = allweeks.filter((n) => !avilabelsDays.includes(n));
        return (
            <div id={styles.calenderWrapper}>
                <div id={styles.calendar}>
                    <div className={styles.header}>
                        <div
                            className={`${styles.iconAndTextInaRow} ${month > currentMonth ? '' : styles.iconInvisible}`}
                            onClick={month > currentMonth ? this.previous : null}
                        >
                            <span>&#10094;</span>
                        </div>
                        <span>{month.format('jYYYY jMMMM')}</span>
                        <div className={styles.iconAndTextInaRow} onClick={this.next}>
                            <span>&#10095;</span>
                        </div>
                    </div>
                    <DayNames />
                    <RenderWeeks
                        select={this.select}
                        month={month}
                        selected={selectedDay}
                        forbiddenDays={forbiddenDays}
                        choicedDay={choicedDay}
                    />
                </div>
            </div>
        );
    }
}

export default Calendar;
